import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';

import { SkywCommonProps } from 'libs/types';
import { MEDIA_SIZE_LIST } from 'libs/const';

import Header from 'components/skyw/Header';
import Skycam from 'components/skyw/Skycam';
import Weather from 'components/skyw/Weather';

interface SkywProps extends SkywCommonProps {
  title: string;
  obsId: number;
}

const Background = styled.div`
  min-height: 100vh;
  background: linear-gradient(20deg, rgba(60, 64, 65, 1) 7%, rgba(107, 106, 104, 0.1) 20%, rgba(0, 0, 0, 0) 50%),
    linear-gradient(127deg, rgba(30, 33, 34, 1), rgba(0, 0, 0, 0) 30%),
    linear-gradient(217deg, rgba(31, 34, 34, 1), rgba(0, 0, 0, 0) 90%),
    linear-gradient(330deg, rgba(57, 56, 53, 1) 9%, rgba(107, 106, 104, 0.1) 20%, rgba(0, 0, 0, 0) 50%),
    linear-gradient(rgba(30, 33, 34, 1) 20%, rgba(30, 33, 34, 0.7));
`;

const Layout = styled.div`
  margin-top: 30px;
  display: flex;
  align-items: center;
  gap: 20px;
`;

const SkycamWrapper = styled.div`
  flex: 0.45;
`;

const WeatherWrapper = styled.div`
  flex: 0.55;
`;

const Wrapper = styled.div`
  padding: 40px 30px;
  max-width: 1280px;
  margin: 0 auto;
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;

  @media screen and (max-width: ${`${MEDIA_SIZE_LIST[1]}px`}) {
    padding: 40px 20px;
    ${Layout} {
      flex-direction: column;
      gap: 40px;
    }
    ${SkycamWrapper}, ${WeatherWrapper} {
      flex: 1;
      width: 100%;
    }
    ${SkycamWrapper} {
      border-bottom: 1px solid #606060;
      padding-bottom: 30px;
    }
  }
`;

const Skyw = ({ obsId, title }: SkywProps) => {
  return (
    <>
      <Helmet title={`${title} - OWL INFO`} />
      <Background>
        <Wrapper>
          <Header title={title} obsId={obsId} />
          <Layout>
            <SkycamWrapper>
              <Skycam obsId={obsId} />
            </SkycamWrapper>
            <WeatherWrapper>
              <Weather obsId={obsId} />
            </WeatherWrapper>
          </Layout>
        </Wrapper>
      </Background>
    </>
  );
};

export default Skyw;
